import {
    Component,
    OnInit,
    OnDestroy,
    HostBinding,
    AfterViewInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as LinkFileListActions from '../../actions/link-file-list.actions';
import { BehaviorSubject, Subject, Subscription, debounceTime, takeUntil, delay } from 'rxjs';
import { ThumbnailsService } from '../../file-list/services/thumbnails.service';
import { BrowserSupportService } from '../../core/browser-support.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { LoggerService } from '../../core/logger.service';
import { BuildTransferItemService } from '../../transfer/services/build-transfer-item.service';
import { FileItemService } from '../../file/file-item.service';
import { canBrowserOpen, getFileExt } from '../../shared/func';
import { ActivatedRoute, Router } from '@angular/router';
import { RunUploadFolderService } from 'src/app/transfer/services/run-upload-folder.service';
import { BlendEvent, FileItem, TransferItem } from '../../shared/models';
import { BlendService } from '../../shared/services/blend.service';
import { IFile, IPaginate, IUploadFolderView } from 'src/sync';
import { Entry } from 'src/app/filewriter';
import { TransferService } from 'src/app/transfer/services/transfer.service';
import { UploadFolderService } from 'src/app/transfer/services/upload-folder.service';
import { CellTypes, Column, Breadcrumb, LazyLoadingPagination, Pagination, UtilService } from '@material-library';
import { LinkFileListService } from '../services/link-file-list.service';
import { AppBarActionsService } from 'src/app/shared/layout/root-layout/app-bar-actions.service';
import { RootLayoutConfigService } from 'src/app/shared/layout/root-layout/root-layout-config.service';
import { FileViewService } from 'src/app/file/file-view.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { DownloadZipService } from 'src/app/transfer/services/download-zip.service';
import { environment } from '../../../environments/environment';
import { BaseFileListComponent } from "../../shared/components/base-file-list/base-file-list.component";
import { IPaginationConfig } from "../../shared/types";
import { PageEvent } from '@angular/material/paginator';
import { ExternalNavigationHandlerService } from "../../transfer/services/external-navigation-handler.service";
import { TransferWidgetNavigationService } from "../../shared/services/transfer-widget-navigation.service";

@Component({
    selector: 'app-link-file-list',
    templateUrl: './link-file-list.component.html',
    styleUrls: ['./link-file-list.component.scss', '../../file-list/file-list/file-list.component.scss']

})
export class LinkFileListComponent extends BaseFileListComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('cellTemplate') cellTemplateRef: TemplateRef<any>;
    @ViewChild('iconTemplate') iconTemplateRef: TemplateRef<any>;

    public cwd: IFile;
    public upload: number;
    public canSave: boolean;
    public previewonly: 0 | 1;
    public compat = 0;
    public initialized: boolean;
    public isRoot: boolean;
    //white label attributes
    public isWhiteLabel: boolean;
    public linkTextColor: String;

    public allowComment: 0 | 1 | 2;

    private isBusiness: 0 | 1;

    public UPLOAD_NON_VISIBLE = 2;
    public UPLOAD_VISIBLE = 1;
    public UPLOAD_DISABLED = 0;
    public isTransfering: boolean;
    private key: string;
    private passlock: string;
    public folderTransferView: IUploadFolderView;
    dropFolder?: FileItem;
    public breadcrumbItems: Array<Breadcrumb> = [];
    public openUploadDialog: boolean = false;
    private isSmScreen: boolean = false;
    public listService = this.linkFileListService;
    
    constructor(
        private browserSupport: BrowserSupportService,
        private store: Store<fromRoot.State>,
        private thumbnailsService: ThumbnailsService,
        private sanitizer: DomSanitizer,
        private log: LoggerService,
        public transferService: TransferService,
        private uploadFolderService: UploadFolderService,
        private buildTransferItemService: BuildTransferItemService,
        protected fileItemService: FileItemService,
        protected utils: UtilService,
        public route: ActivatedRoute,
        private router: Router,
        private runUploadFolderService: RunUploadFolderService,
        private blendService: BlendService,
        private linkFileListService: LinkFileListService,
        private appBarActionsService: AppBarActionsService,
        private rootLayoutConfigService: RootLayoutConfigService,
        private fileViewService: FileViewService,
        public breakpointObserver: BreakpointObserver,
        private pageTitleService: Title,
        private downloadZipService: DownloadZipService,
        private externalNavigationService: ExternalNavigationHandlerService,
        private transferWidgetNavigationService: TransferWidgetNavigationService
    ) {
       super(utils, fileItemService, route)
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.isLoading = true;
        this.folderTransferView = this.runUploadFolderService.view;
        
        this.initTableData();
        this.initSubscribers();
    }

    public ngAfterContentInit(): void {
        this.store.select(fromRoot.getLinkFileListState)
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe((data) => {
                this.previewonly = data.previewonly;
                this.upload = data.upload;
                this.key = data.linkkey;
                this.compat = data.compat;
                this.isRoot = data.is_root;
                this.isBusiness = data.is_business;
                if (data.error) {
                    this.log.error(`Link file list received Error: ${data.error.code}: ${data.error.msg}`);
                }
                if (data.cwd) {
                    this.cwd = data.cwd;
                    this.pageTitleService.setTitle(
                        `${this.cwd.name} | ${this.PAGE_TITLE}`
                    );
                    this.breadcrumbItems = [{
                        label: this.cwd.name,
                        url: false
                    }];
                    if (data.cwd && data.is_root) {
                        let title = '';
                        if (data.cwd.type === 'file') {
                          title = data.cwd.name;
                        } else {
                          this.rootLayoutConfigService.linkRootDirectory = `Link for ${data.cwd.name}`
                          title = this.rootLayoutConfigService.linkRootDirectory;
                        }
                        this.rootLayoutConfigService.updateConfig({linkTitle: title});
                      } else {
                        this.rootLayoutConfigService.updateConfig({linkTitle: this.rootLayoutConfigService.linkRootDirectory});
                    }
                }
               
                this.passlock = data.passwordlock;
                if (data.loaded && data.sorted) {
                    if (
                        data.pathlist.length == 1 &&
                        data.pathlist[0].sync_id == data.cwd.sync_id
                    ) {
                        this.onRowDoubleClick(data.pathlist[0]);
                    } else if (data.upload != this.UPLOAD_NON_VISIBLE) {
                        this.fileList = data.pathlist;
                        this.isLoading = false;
                    }
                   
                    this.isWhiteLabel = !!data.image_cachekey;
                    this.linkTextColor = data.image_cachekey? data.link_text_color : '#00adef';
                    this.allowComment = data.allow_comment;
                   
                    if (!this.isPaginationInitialized && this.fileList.length) {
                        this.initializePagination();
                    }
                    this.setPageData();
                    this.initActions();
                    this.initialized = true;
                    this.isLoading = false;
                }
            });
    }

    public ngOnDestroy() {
       super.ngOnDestroy();
    }

    private initSubscribers(): void {
        this.breakpointObserver
            .observe([`(max-width: 599px)`])
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    // Condition for sm/xs screens
                    this.isSmScreen = true
                } else {
                    this.isSmScreen = false
                }
                this.initColumns();
                this.assignTemplateRefs();
            });
        
        this.paginationConfig$
            .pipe(takeUntil(this.destroySubscriptions$), delay(500))
            .subscribe((paginationConfig)=> {
                if (paginationConfig?.isScrollUpdate || paginationConfig?.isInitialLoading) {
                    this.updateThumbnails(paginationConfig);
                }
            });
    }
    
    private updateThumbnails(paginationConfig : IPaginationConfig): Promise<void> {
        return this.thumbnailsService.getThumbs(this.fileList, paginationConfig, true);
    }

    openUploadFolderModal() {
        this.uploadFolderService.showFolderUpload();
    }

    public changeDir = (id: number) => {
        this.isLoading = true;
        this.store.dispatch(new LinkFileListActions.ChangeDirAction(id));
        this.router.navigate([], {
            relativeTo: this.route,
            ...this.decorateFragment(),
            queryParams: { sync_id: id }
        });
    }

    public async openFolder(data: {transferItem: TransferItem, id: number}){
        if(!data) return;
        const {transferItem, id} = data;
        this.isLoading = true;
        await this.transferWidgetNavigationService.changeDirectoryForLinkFileItem(transferItem, id, this.compat);
    }
    public onDragEnd(event) {
        event.preventDefault();
        event.dataTransfer.effectAllowed = 'none';
        event.dataTransfer.dropEffect = 'none';
        return false;
    }
    public onDragOver(event) {
        event.preventDefault();
        return false;
    }
    public onDrop(event) {
        event.preventDefault();
        const list = event.dataTransfer.items;

        if (list && list.length > 0) {
            if (this.browserSupport.testDirUpload()) {
                let hasDirs = false;
                let items: Entry[] = [];
                for (let i = 0, len = list.length; i < len; i++) {
                    const item: Entry = list[i].webkitGetAsEntry();
                    if (item) {
                        items.push(item);
                        if (!hasDirs && item.isDirectory) {
                            hasDirs = true;
                        }
                    }
                }
                if (hasDirs) {
                    this.uploadFolderService.run(this.cwd, items, this.cwd.linkID);
                } else {
                    items = [];
                    this.transferService.queuePublicUpload(event.dataTransfer.files);
                }
            } else {
                // browser does not support dir upload
                this.transferService.queuePublicUpload(event.dataTransfer.files);
            }
        } else if (event.dataTransfer.files.length) {
            this.transferService.queuePublicUpload(event.dataTransfer.files);
        } else {
            this.log.info('No files were dropped for upload');
        }
        return false;
    }

    public showDownloadAll = () => {
        return (
            this.initialized &&
            !this.previewonly &&
            this.compat == 1 &&
            this.upload != this.UPLOAD_NON_VISIBLE &&
            this.fileList.length > 0
        );
    }

    public showfileTransferModal() {
        this.transferService.showTransfer();
    }

    isTransferComplete() {
        if (this.buildTransferItemService.view.isUpload) {
            this.isTransfering = true;
        } else if (!this.buildTransferItemService.view.isUpload && this.isTransfering && this.upload == 2) {
            this.isTransfering = true;
            return true;
        }
        return false;
    }

    public downloadZipFile = () => {
        this.downloadZipService.createZip(
            this.route.snapshot.params['cachekey'],
            this.passlock,
            this.cwd.name
        )
        this.blendService.track(BlendEvent.DOWNLOAD_AS_ZIP, {});
    }

    /**
     * Downloads a specific file
     * @param  {Object} item The pathitem object
     * @return {Promise}
     */
    public downloadFile = async (item: IFile) => {
        const navigationHandlers = this.externalNavigationService.getHandlers();
        this.externalNavigationService.clearHandlers()
        if (this.compat) {
            if (item.context == 'applink') {
                const url = item.compaturl;
                window.location.href = url;
            } else {
                const url = await this.buildTransferItemService.getCompatUrl(
                    item,
                    this.buildTransferItemService.ACT_DOWNLOAD
                );
                window.location.href = url;
            }
        } else {
            await this.transferService.queuePublicDownload([item]);
            this.transferService.showTransfer();
        }
        setTimeout(()=>{
            this.externalNavigationService.restoreHandlers(navigationHandlers);
        }, 1e3)
    }

    public openFile = async (item: IFile) => {
        if (item.context == 'applink') {
            const url = item.compaturl;
            window.open(url, 'blank');
        } else {
            const url = await this.buildTransferItemService.getCompatUrl(
                item,
                this.buildTransferItemService.ACT_PREVIEW
            );
            window.open(url, 'blank');
        }
    }

    public isOpenable(item: IFile) {
        if (item.context == 'link' && (item.previewonly == 8 || !this.compat)) {
            return false;
        }
        if (
            item.context == 'link' &&
            getFileExt(item.name) == 'pdf' &&
            !item.link_is_business
        ) {
            return false;
        }
        if (this.isMSOffice(item)) {
            return false;
        }

        if (!canBrowserOpen(item.name)) {
            return false;
        }
        if (item.context == 'link' && this.fileItemService.isStreamable(item.kind)) {
            return false;
        }
        return true;
    }

    public isPreviewable(item: IFile) {
        if (!this.compat && (this.fileItemService.isImage(item) || this.fileItemService.isText(item))) {
            return true;
        }
        if (this.compat &&
            (!item.transferitem &&
                item?.filetype?.viewable ||
                this.fileItemService.isStreamable(item.kind)
            )
        ) {
            return true;
        }
        return false;
    }

    public isMSOffice(item: IFile) {
        const app = this.fileItemService.getMSOfficeApp(item);
        if (app === 'None') {
            return false;
        }
        return true;
    }
    
    public onUpload = (files) => {
        this.transferService.queuePublicUpload(files);
    }

    private decorateFragment() {
        if (!this.compat || this.route.snapshot.fragment) {
            return { fragment : this.route.snapshot.fragment };
        }
    }
    
    private initTableData() {
       this.initColumns();
    }
    
    protected initColumns(): void {
        this.fileListColumns = [
            {
                key: 'head',
                header: '',
                isHead: true,
                type: CellTypes.templateRef,
                width: '48px',
                cell: (element: Record<string, any>) => {
                    return this.fileItemService.getFileTypeIcon(element)
                },
            },
            {
                key: 'name',
                header: 'Name',
                type: CellTypes.templateRef,
                isSortable: true,
                isPrimary: true,
                cell: (element: Record<string, any>) => {
                    return {
                        value: `${element['name'] || '-'}`
                    };
                },
                sort: (isSortAsc: boolean) => {
                    this.linkFileListService.sortList('name', isSortAsc);
                    this.handleFilterOrSortingChanged();
                }
            },
            {
                key: 'modified',
                header: 'Modified',
                type: CellTypes.text,
                width: '190px',
                visibleMaxWidth: 725,
                cell: (element: Record<string, any>) => `${element.is_dir ? '-' : element['date_medium']}`,
                isSortable: true,
                sort: (isSortAsc: boolean) => {
                    this.linkFileListService.sortList('usertime', isSortAsc);
                    this.handleFilterOrSortingChanged();
                }
            },
            {
                key: 'size',
                header: 'Size',
                type: CellTypes.text,
                width: '90px',
                visibleMaxWidth: 815,
                isAlignRight: true,
                cell: (element: Record<string, any>) => `${element.is_dir ? '-' : element['filesize']}`,
                isSortable: true,
                sort: (isSortAsc: boolean) => {
                    this.linkFileListService.sortList('size', isSortAsc);
                    this.handleFilterOrSortingChanged();
                }
            },
            {
                key: 'action',
                header: 'Actions',
                type: CellTypes.action,
                width: '152px',
                isAlignRight: true,
                actionLimit: 0,
                actions: [
                    {
                        name: 'Encrypted file. No actions available.',
                        onClick: () => { },
                        shouldShow: (item: FileItem) => item.type == 'file' && !this.compat && this.previewonly &&
                            !(this.fileItemService.isImage(item) || this.fileItemService.isText(item)),
                    },
                    {
                        name: 'No actions available.',
                        onClick: () => { },
                        shouldShow: (item: FileItem) => item.type == 'file' && (!item?.filetype?.viewable &&
                                this.previewonly &&
                                !this.fileItemService.isStreamable(item.kind)) &&
                            this.compat,
                    },
                    {
                        name: 'Preview',
                        icon: 'preview',
                        onClick: this.onRowDoubleClick,
                        shouldShow: (item: FileItem) => item.type == 'file' && this.isPreviewable(item)
                    },
                    {
                        name: 'Open in browser',
                        icon: 'open-in-new',
                        onClick: this.openFile,
                        shouldShow: (item: FileItem) => item.type == 'file' && this.isOpenable(item)
                    },
                    {
                        name: 'Download',
                        icon: 'download',
                        onClick: this.downloadFile,
                        shouldShow: (item: FileItem) => item.type == 'file' && !this.previewonly,
                    },
                    {
                        name: 'Edit in Office',
                        icon: 'edit',
                        onClick: (item: FileItem) => {
                            this.fileViewService.openOfficeEdit(item, this.route);
                        },
                        shouldShow: (item: FileItem) => item.type == 'file' && this.fileViewService.showOfficeEdit(item) && !this.isSmScreen
                    },
                    {
                        name: 'View in Offce',
                        icon: 'preview',
                        onClick: (item: FileItem) => {
                            this.fileViewService.openOfficeView(item);
                        },
                        shouldShow: (item: FileItem) => item.type == 'file' && this.fileViewService.showOfficeEdit(item) && this.isSmScreen
                    }
                ]
            }
        ].filter(Boolean) as Column[];
    }
    

    onRowDoubleClick = async (item: FileItem) => {
        if (item.type === 'dir') {
            this.changeDir(item.sync_id);
        } else {
            await this.handlePreviewFile(item);
        }
    }

   public async handlePreviewFile (item: FileItem | TransferItem): Promise<void> {
        await this.transferWidgetNavigationService.previewItem(item, this.compat, this.isBusiness);
    }
    
    onUploadAction = () => {
        this.openUploadDialog = true;
    }

    private initActions(): void {
        this.appBarActionsService.updateActions({
            limit: 5,
            actions: [{
                name: 'Upload',
                onClick: this.onUploadAction,
                icon: 'upload',
                shouldShow: () => this.upload,
                type: 'primary'
            }, {
                name: 'Download all',
                onClick: this.downloadZipFile,
                icon: 'download',
                shouldShow: this.showDownloadAll,
                type: 'primary'
            }],
            rowData: this.fileList
        })
    }
    
    protected updateDataContainerScroll(): void {}
    protected onSearch = () => {}
    protected onFilterIconClicked(): void {}
}
